module.exports = __webpack_public_path__ + "img/尊享功能.443deac2.png";